import { render } from "./MyClients.vue?vue&type=template&id=3b270356"
import script from "./MyClients.vue?vue&type=script&lang=js"
export * from "./MyClients.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__